import { gql } from '@apollo/client';
import type IEmployeeTalk from '@sharedInterfaces/IEmployeeTalk';
import EmployeeTalk, { EmployeeTalkGQL } from '@src/Objects/EmployeeTalk';
import { setEmployeeTalks } from '@store/reducer/employeeTalksReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const q = gql`
  query GetEmployeeTalks {
    employeeTalks ${EmployeeTalkGQL}
  }
`;

export default async function getEmployeeTalks(): Promise<EmployeeTalk[]> {
    return GraphQL.query<{ employeeTalks: IEmployeeTalk[] }>(q, {}).then((obj) => {
        if (!obj) throw new Error('Fehler beim Laden der Mitarbeitergespräche.');

        if (obj.employeeTalks) {
            const data = obj.employeeTalks.map((talk) => new EmployeeTalk(talk));
            store.dispatch(setEmployeeTalks(data));
            return data;
        }

        return store.getState().employeeTalks || [];
    });
}
